const fonts = {
    heading: "IBM Plex Serif",
    body: "Nunito",
};

export default fonts;